<template>
  <div>
    <Nav />
    <Banner :title="title" v-if="selectedPost === false" />

    <div class="posts" v-if="selectedPost === false">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="position-relative">
              <input
                type="text"
                class="search-item"
                :placeholder="'Search ' + title"
                v-model="query"
              />
              <i class="fas fa-search position-absolute search-icon"></i>
            </p>
          </div>
        </div>
        <div class="row" v-if="title.indexOf('events') > -1">
          <div class="col-12 mb-3">
            <v-date-picker
              color="green"
              mode="single"
              is-expanded
              is-inline
              :attributes="attributes"
              v-model="selectedEvent"
            />
          </div>
        </div>
        <div class="row">
          <template v-if="relatedItems.length">
            <div
              :key="title + '-' + index"
              v-for="(item, index) in relatedItems"
              class="col-sm-12 col-md-4 col-lg-4"
            >
              <div class="card my-3">
                <figure class="post-image">
                  <img
                    v-if="item.image"
                    :src="getImage(item.image)"
                    class="card-img-top"
                  />
                  <img v-else :src="placeholderImage()" class="card-img-top" />
                </figure>
                <div class="card-body">
                  <h5 class="card-title text-center my-3">
                    {{ item.title | niceTitle }}
                  </h5>
                  <h6 class="card-title text-center mb-3">
                    <small>{{ item.created | niceDate }}</small>
                  </h6>
                  <p class="text-center">
                    <button
                      href="#"
                      class="btn btn-primary"
                      @click="selectedPost = item"
                    >
                      {{ title === "news" ? "Read Article" : "View Event" }}
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div>
              <p class="my-5 text-center">
                No {{ title }} to display at this time. Please check back again
                later. Thank you.
              </p>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="show-post p-3" v-else>
      <div
        v-if="selectedPost.image"
        class="post-hero text-center rounded"
        :style="'background-image: url(' + getImage(selectedPost.image) + ');'"
      >
        <h3>{{ selectedPost.title | niceTitle }}</h3>
        <h4>{{ selectedPost.created | niceDate }}</h4>
      </div>
      <div
        v-else
        class="post-hero text-center rounded"
        :style="'background-image: url(' + placeholderImage() + ');'"
      >
        <h3>{{ selectedPost.title | niceTitle }}</h3>
        <h4>{{ selectedPost.created | niceDate }}</h4>
      </div>
      <div class="post-content position-relative py-5">
        <div class="container">
          <div class="row">
            <div class="col">
              <div v-html="selectedPost.content"></div>
              <p class="position-absolute back-btn">
                <button class="btn btn-primary" @click="selectedPost = false">
                  <i class="fas fa-chevron-left mr-1"></i> Back
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
import axios from "axios";
import moment from "moment";


export default {
  name: "Events",
  components: {
    Banner: Banner
  },
  props: {
    title: {
      type: String,
      default: () => ""
    }
  },
  data: () => ({
    items: [],
    relatedItems: [],
    query: "",
    placeholderImages: [
      require("@/assets/images/events_1.jpg"),
      require("@/assets/images/events_2.jpg"),
      require("@/assets/images/events_3.jpg"),
      require("@/assets/images/chaplin_2.jpg"),
      require("@/assets/images/chaplin_3.jpg"),
      require("@/assets/images/chaplin_4.jpg"),
      require("@/assets/images/news_1.jpg"),
      require("@/assets/images/news_2.jpg")
    ],
    selectedPost: false,
    attributes: [],
    selectedEvent: null
  }),
  created() {
    this.getItems();
  },
  methods: {
    getImage(value) {
      return process.env.VUE_APP_IMAGES + value;
    },
    getItems() {
      axios
        .get(process.env.VUE_APP_SERVER + this.title)
        .then(res => {
          if (res.data) {
            this.items = res.data.result.reverse();
            this.relatedItems = res.data.result.reverse();
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    showRelatedItems() {
      this.relatedItems = this.items.filter(i => {
        if (
          (i.title && i.title.toLowerCase().indexOf(this.query) > -1) ||
          (i.content && i.content.toLowerCase().indexOf(this.query) > -1)
        ) {
          return i;
        }
      });
    },
    placeholderImage() {
      let eIndex = Math.floor(Math.random() * this.placeholderImages.length);
      if (eIndex > this.placeholderImages.length - 1) eIndex -= 1;
      const image = this.placeholderImages[eIndex];
      return image;
    },
    selectEvent(value) {
      if (!value) this.relatedItems = this.items;
      else {
        let selected = moment
          .utc(value)
          .toISOString()
          .split("T");
        this.relatedItems = this.items.filter(i => {
          let date = i.created.split("T");
          if (date[0] === selected[0]) {
            return i;
          }
        });
      }
    }
  },
  filters: {
    niceDate(value) {
      return "Published " + moment.utc(value).format("MMM Do YYYY");
    },
    niceTitle(value) {
      if (value.indexOf(" ") > -1) {
        return value
          .split(" ")
          .map(w => {
            return w[0].toUpperCase() + w.substring(1);
          })
          .join(" ");
      } else {
        return value[0].toUpperCase() + value.substring(1);
      }
    }
  },
  watch: {
    query() {
      if (this.query.length > 2) {
        this.showRelatedItems();
      } else {
        this.relatedItems = this.items;
      }
    },
    relatedItems() {
      if (this.title === "events") {
        this.attributes = [];
        this.relatedItems.forEach(r => {
          this.attributes.push({
            popover: {
              label: r.title
            },
            key: r.title,
            highlight: true,
            dates: moment.utc(r.created).toISOString()
          });
        });
      }
    },
    selectedEvent() {
      this.selectEvent(this.selectedEvent);
    }
  }
};
</script>

<style lang="scss">
.search-item {
  border: solid 1px #ccc;
  border-radius: 20px;
  padding: 0.45rem;
  padding-left: 1rem;
  &:focus {
    outline: none;
  }
}

.search-icon {
  top: 12px;
  left: 168px;
  color: #ccc;
}

.posts {
  padding: 3rem 0;

  .post-image {
    margin: 0 0 1rem;
    max-height: 165px;
    overflow: hidden;

    margin-bottom: 1rem;

    img {
      position: relative;
      width: 110%;
      left: -5%;
      top: -5%;
    }
  }
}

.post-hero {
  background-size: 100%;
  background-position: 50%;
  min-height: 200px;
  h3 {
    padding-top: 4rem;
  }
  h4 {
    padding-bottom: 3rem;
  }
  h3,
  h4 {
    text-shadow: 0 0 5px #000;
    color: #fff;
  }
}

.post-content {
  min-height: 70vh;
  .col {
    min-height: 100%;
  }
}

.back-btn {
  text-align: right;
}
</style>
